__turbopack_context__.v({
  "contactForm": "contact-module__xwJ-uq__contactForm",
  "contactInfo": "contact-module__xwJ-uq__contactInfo",
  "fillImage": "contact-module__xwJ-uq__fillImage",
  "formGroup": "contact-module__xwJ-uq__formGroup",
  "header": "contact-module__xwJ-uq__header",
  "icon": "contact-module__xwJ-uq__icon",
  "imageWrapper": "contact-module__xwJ-uq__imageWrapper",
  "infoItem": "contact-module__xwJ-uq__infoItem",
  "linksInfo": "contact-module__xwJ-uq__linksInfo",
  "main": "contact-module__xwJ-uq__main",
  "page": "contact-module__xwJ-uq__page",
  "submitButton": "contact-module__xwJ-uq__submitButton",
});
